import { useTranslation } from "react-i18next";

const OrbitHoverDetails = (props: any) => {
  const { planetHoverDetails } = props;
  const { t } = useTranslation();
 if(planetHoverDetails?.children?.length) return(<></>)
  return (
    <div className={`  text-white mohave  px-3 `}>
      {planetHoverDetails?.pro_id && (
        <div className={`  sub-font  mt-5`}>
          <div className="row my-2">
            <p className={` col mb-0 opacity-50 `}>{t("planet")}</p>
            <div className={` col mb-0  `}>
              <img
                src={planetHoverDetails.category_image}
                width="15px"
                height="15px"
              />
            </div>
          </div>
          <div className="row my-2">
            <p className={` col mb-0 opacity-50 `}>{t("planet_name")}</p>
            <p className={` col mb-0   truncate-2-lines `}>{planetHoverDetails?.pro_name}</p>
          </div>
          <div className="row my-2 ">
            <p className={`col mb-0 opacity-50 `}>{t("planet_sub_name")}</p>
            <p className={`  col mb-0  truncate-2-lines `}>{planetHoverDetails?.pro_sub}</p>
          </div>
          <div className="row my-2 ">
            <p className={`col mb-0 opacity-50 `}>{t("planet_owner")}</p>

            <p className={`col  mb-0  `}>
              {planetHoverDetails?.pro_owner_name}
            </p>
          </div>
          <div className="row my-2 ">
            <p className={`col mb-0 opacity-50 `}>{t("status")}</p>
            <p className={`  col mb-0  `}>
              <span
                className={`${
                  planetHoverDetails?.pro_status_id === 1
                    ? "bg-warning text-dark"
                    : planetHoverDetails?.pro_status_id === 2
                    ? "bg-info text-dark"
                    : planetHoverDetails?.pro_status_id === 3
                    ? "bg-primary text-white"
                    : planetHoverDetails?.pro_status_id === 4
                    ? "bg-success text-white"
                    : "bg-danger text-white"
                }  px-1 rounded`}
              >
                {planetHoverDetails?.pro_status_name}
              </span>
            </p>
          </div>
          {planetHoverDetails?.pro_address && (
            <div className="row my-2">
              <p className={`col mb-0 opacity-50 `}>{t("address")}</p>
              <p className={`  col mb-0  `}>
                {planetHoverDetails?.pro_address}
              </p>
            </div>
          )}
          {planetHoverDetails?.pro_contact_name && (
            <div className="row my-2">
              <p className={`col mb-0 opacity-50 `}>{t("contact_name")}</p>
              <p className={`  col mb-0  `}>
                {planetHoverDetails?.pro_contact_name}
              </p>
            </div>
          )}
          {planetHoverDetails?.pro_contact_email && (
            <div className="row my-2 ">
              <p className={`col mb-0 opacity-50 `}>{t("contact_email")}</p>
              <p className={`  col mb-0  `}>
                {planetHoverDetails?.pro_contact_email}
              </p>
            </div>
          )}
          {planetHoverDetails?.pro_contact_phone && (
            <div className="row  my-2">
              <p className={`col mb-0 opacity-50 `}>{t("contact_phone")}</p>
              <p className={`  col mb-0  `}>
                {planetHoverDetails?.pro_contact_phone}
              </p>
            </div>
          )}
          {planetHoverDetails?.pro_desc && (
            <div className="row my-2 ">
              <p className={`col mb-0 opacity-50 `}>{t("planet_desc")}</p>
              <p
                className={`  col mb-0 truncate-2-lines  `}
                dangerouslySetInnerHTML={{
                  __html: planetHoverDetails?.pro_desc,
                }}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default OrbitHoverDetails;
